import type { AllarmeDTO, NuovoAllarmeDTO } from '@/models/dto/allarme/allarme-dto'
import type { Alarm, NewAlarm } from '@/models/types/alarm/alarm'
import { mapToFacility, mapToImpiantoDTO } from '../facility/facility-mapper'
import { mapToEarthquake, mapToSismaDTO } from '../plc/earthquake-mapper'
import { mapToUser, mapToUtentiDTO } from '../user/user-mapper'

const mapToAlarm = (dto: AllarmeDTO): Alarm => {
    return { ...mapToNewAlarm(dto), id: dto.id }
}

const mapToAllarmeDTO = (alarm: Alarm): AllarmeDTO => {
    return { ...mapToNuovoAllarmeDTO(alarm), id: alarm.id }
}

const mapToNewAlarm = (dto: NuovoAllarmeDTO): NewAlarm => {
    return {
        description: dto.descrizione ?? null,
        note: dto.note,
        timestampstart: dto.timestampStart,
        timestamplast: dto.timestampLast,
        maxThreshold: dto.rMaxThreshold,
        minThreshold: dto.rMinThreshold,
        ackTimestamp: dto.timestampAck,
        facilityId: dto.idImpianto,
        facility: mapToFacility(dto.impianti),
        userId: dto.idUtente ?? undefined,
        user: dto.utenti ? mapToUser(dto.utenti) : undefined,
        earthquakes: dto.sismaDTONav?.map(mapToEarthquake) ?? null,
        sensorId: dto.idSensore,
        sensorName: dto.aliasIdSensore ?? null,
        state: dto.stato,
        archived: dto.archiviato,
        shared: dto.condiviso,
        category: dto.category,
    }
}

const mapToNuovoAllarmeDTO = (alarm: NewAlarm): NuovoAllarmeDTO => {
    return {
        descrizione: alarm.description ?? null,
        stato: alarm.state,
        note: alarm.note ?? '',
        timestampStart: alarm.timestampstart,
        timestampLast: alarm.timestamplast,
        rMaxThreshold: alarm.maxThreshold,
        rMinThreshold: alarm.minThreshold,
        timestampAck: alarm.ackTimestamp,
        idImpianto: alarm.facilityId,
        impianti: mapToImpiantoDTO(alarm.facility),
        idUtente: alarm.userId ?? null,
        utenti: alarm.user ? mapToUtentiDTO(alarm.user) : null,
        sismaDTONav: alarm.earthquakes?.map(mapToSismaDTO) ?? null,
        idSensore: alarm.sensorId,
        aliasIdSensore: alarm.sensorName ?? null,
        archiviato: alarm.archived,
        condiviso: alarm.shared,
        category: alarm.category,
    }
}

export { mapToAlarm, mapToAllarmeDTO, mapToNewAlarm, mapToNuovoAllarmeDTO }
